import React, { useState } from 'react';
import {
  Pagination,
  Container,
  Content,
  useToaster,
  Message
} from 'rsuite';
import './style.css';
import ActionConfirmationModal from './ActionCornfirmationModala';
import DashboardStats from './DashboardStats';
import ReportDetailDrawer from './ReportDetailDrawer';
import ModerationTable from "../../components/ moderation/ModerationTable"
import {reportedColumns, blockedColumns} from "../../components/ moderation/moderationColumns"
import services from '../../services';
import { useAuth } from '../../Provider/Authcontext';

const CustomTabs = ({ activeKey, onSelect, children }) => (
  <div className="bg-white border border-gray-200 rounded-lg">
    <div className="border-b w-96 border-gray-200">
      <nav className="flex space-x-8 px-6">
        <button
          onClick={() => onSelect('reported')}
          className={`py-4 px-1 border-b-2 font-medium text-sm ${
            activeKey === 'reported' ? 'border-teal-500 text-teal-600' : 'border-transparent text-gray-500 hover:text-gray-700'
          }`}
        >
          Reported Posts
        </button>
        <button
          onClick={() => onSelect('blocked')}
          className={`py-4 px-1 border-b-2 font-medium text-sm ${
            activeKey === 'blocked' ? 'border-teal-500 text-teal-600' : 'border-transparent text-gray-500 hover:text-gray-700'
          }`}
        >
          Blocked Users
        </button>
      </nav>
    </div>
    <div className="p-6">{children}</div>
  </div>
);

export const ModerationDashboard = () => {
  const [activeTab, setActiveTab] = useState('reported');
  const [selectedReport, setSelectedReport] = useState(null);
  const [selectedUser, setSelectedUser] = useState(null);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalContent, setModalContent] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(7);
  const [selectedReportId, setSelectedReportId] = useState(null);
  const toaster = useToaster();
  const { userId } = useAuth();

  const currentUserId = userId; 
  
  const { data: reportedPosts = [], isLoading: reportsLoading, isError: reportsError } =
    services.moderation.useReportedPosts(); 
  const { data: reportDetails, isLoading: reportLoading} =
    services.moderation.useReportDetails(selectedReportId);
  const { data: blockedUsers = [], isLoading: blockedLoading } =
    services.moderation.useBlockedUsers?.() || { data: [], isLoading: false };
  const { data: removedPosts = []} =
    services.moderation.useRemovedPosts()
  const { mutate: deletePostMutate,  } = services.moderation.useDeletePost();
  const { mutate: dismissMutate} = services.moderation.useDismissReport();
  const { mutate: blockMutate} =services.moderation.useBlockUser();
 

  const totalReportsCount = reportedPosts.reduce(
    (acc, curr) => acc + curr.numberOfReports,
    0
  );

  const removedPostsCount = removedPosts.length;

  const showToast = (type, text) => {
    toaster.push(
      <Message showIcon type={type} closable>
        {text}
      </Message>,
      { placement: 'topEnd', duration: 3000 }
    );
  };

  const openActionModal = async(action, row) => {
    if (['delete', 'dismiss'].includes(action)) {
      setSelectedReport(row);
      setSelectedUser(null);
    } else if (action === 'block' && row?.blog) {
      setSelectedReport(row);
      setSelectedUser(row?.blog?.user);
    } else if (['block', 'unblock'].includes(action)) {
      setSelectedUser(row);
      setSelectedReport(null);
    } else {
        setSelectedReport(null);
        setSelectedUser(null);
    }
    
    if (action === 'block' && !row && selectedReport?.blog?.user) {
        setSelectedUser(selectedReport.blog.user);
    }

    const modalConfigs = {
      delete: {
        message: 'Are you sure you want to delete this post from the feeds?',
        actionText: 'Delete Post',
        isDestructive: true,
        showReasonInput: true,
      },
      dismiss: {
        message: 'Are you sure you want to dismiss this report?',
        actionText: 'Dismiss Report',
        isDestructive: false,
        showReasonInput: true,
      },
      block: {
        message: `Are you sure you want to block this user (${selectedUser?.username || row?.username || 'user'})?`,
        actionText: 'Block User',
        isDestructive: true,
        showReasonInput: true,
      },
      unblock: {
        message: `Are you sure you want to unblock this user (${row?.username || 'user'})?`,
        actionText: 'Unblock User',
        isDestructive: false,
        showReasonInput: true,
        reportData: row
      },
    };

    setModalContent(modalConfigs[action] || {});
    setIsModalOpen(true);
  };

const handleDeletePost = async (reason) => {

  if (!selectedReport?.blogId) {
      showToast('error', 'Error: Post ID not found.');
      return;
  }
  deletePostMutate(
    { blogId: selectedReport.blogId, deletedById: currentUserId, reason },
    {
      onSuccess: () => {
        showToast('success', 'Post deleted successfully');
      },
      onError: () => {
        showToast('error', 'Failed to delete post');
      },
    }
  );
};

const handleDismissReport = async (reason) => {
  if (!selectedReport?.blogId) {
    console.error("Dismiss Report: blogId is missing from selectedReport.");
    showToast('error', 'Error: Report ID not found.');
    return;
  }
  dismissMutate(
    { blogId: selectedReport.blogId, dismissedById: currentUserId, reason },
    {
      onSuccess: () => {
        showToast('success', 'Report dismissed successfully');
      },
      onError: () => {
        showToast('error', 'Failed to dismiss report');
      },
    }
  );
};


const handleBlockUser = async (reason) => {
  const userId = reportDetails?.blog?.userId || selectedReport?.blog?.user?.id || selectedReport?.blog?.userId || selectedUser?.id;
  
  if (!userId) {
    console.error("Block User: User ID is missing.");
    showToast('error', 'Error: User ID not found.');
    return;
  }
  const blogId = selectedReport?.blogId || selectedReportId || reportDetails?.blog?.id || reportDetails?.blog?.blogId || selectedReport?.blog?.id;
  
  if (!blogId) {
    console.error("Block User: Blog ID is missing.");
    showToast('error', 'Error: Post ID not found.');
    return;
  }
  
  blockMutate(
    { userId: userId, blockedById: currentUserId, reason },
    {
      onSuccess: () => {
        showToast('success', 'User blocked successfully');
        deletePostMutate(
          { blogId: blogId, deletedById: currentUserId, reason: `Post deleted due to user being blocked. ${reason || ''}` },
          {
            onSuccess: () => {
              showToast('success', 'Post deleted successfully');
            },
            onError: () => {
              showToast('error', 'User blocked but failed to delete post');
            },
          }
        );
      },
      onError: () => {
        showToast('error', 'Failed to block user');
      },
    }
  );
};

const handleUnblockUser = async (reason) => {
  if (!selectedUser?.id) {
    console.error("Unblock User: User ID is missing from selectedUser.");
    showToast('error', 'Error: User ID not found.');
    return;
  }
  blockMutate( 
     { userId: selectedUser.id, blockedById: currentUserId, reason }, 
    {
      onSuccess: () => {
        showToast('success', 'User unblocked successfully');
      },
      onError: () => {
        showToast('error', 'Failed to unblock user');
      },
    }
  );
};

const handleConfirmAction = async (reason) => {

  if (!modalContent.actionText || (!selectedReport && !selectedUser)) {
      console.error("handleConfirmAction failed: Missing action or target.");
      setIsModalOpen(false);
      return;
  }
  
  const { actionText } = modalContent;
  try {
    switch (actionText) {
      case 'Delete Post':
        await handleDeletePost(reason);
        break;
      case 'Dismiss Report':
        await handleDismissReport(reason);
        break;
      case 'Block User':
        if (selectedReport && !selectedUser) {
             setSelectedUser(selectedReport?.blog?.user); 
        }
        await handleBlockUser(reason);
        break;
      case 'Unblock User':
        await handleUnblockUser(reason);
        break;
      default:
        console.warn(`Unknown action: ${actionText}`);
    }
  } catch (error) {
    console.error(`Error in ${actionText}:`, error);
  }
  setIsModalOpen(false);
  setIsDrawerOpen(false);
  setSelectedReport(null);
  setSelectedUser(null);
};


  const handleViewReport = async (row) => {
    setSelectedReport(row);
    setIsDrawerOpen(true);
    setSelectedReportId(row.blogId); 
  };

  const handleUnblock = (row) => openActionModal('unblock', row);
  const handleDrawerBlockClick = () => {
    openActionModal('block', selectedReport);
  }

  return (
    <div className="min-h-screen bg-gray-50">
      <Container>
        <Content className="p-8">
          <div className="max-w-7xl mx-auto">
            <h1 className="text-3xl font-bold text-gray-900 mb-2">Moderation Dashboard</h1>
            <p className="text-gray-600 mb-8">Manage reported content and user management</p>

            {/* Stats */}
            <DashboardStats
              pending={reportedPosts.filter(r => r.status === 0).length}
              total={totalReportsCount}
              blocked={blockedUsers.length}
              removed={removedPostsCount}
            />

            {/* Tabs */}
            <CustomTabs activeKey={activeTab} onSelect={setActiveTab}>
              {activeTab === 'reported' && (
                <>
                  {reportsError && <p className="text-red-500 mb-4">Failed to load reported posts.</p>}
                  <div className="mb-6 font-bold">{reportedPosts.length} reported posts</div>
                  <ModerationTable
                    data={reportedPosts.slice(
                      (currentPage - 1) * pageSize,
                      currentPage * pageSize
                    )}
                    columns={reportedColumns(handleViewReport)}
                    loading={reportsLoading}
                    flexGrow={2}
                  />

                  {/* Pagination */}
                  <div className="flex items-center justify-between mt-4">
                    <Pagination
                      prev
                      next
                      ellipsis
                      boundaryLinks
                      maxButtons={5}
                      size="md"
                      total={reportedPosts.length}
                      limit={pageSize}
                      activePage={currentPage}
                      onChangePage={setCurrentPage}
                    />
                    <div className="flex items-center space-x-3">
                      <span className="text-sm text-gray-600">Posts per page:</span>
                      <select
                        className="border border-gray-300 rounded px-3 py-1 text-sm bg-white"
                        value={pageSize}
                        onChange={(e) => {
                          setPageSize(Number(e.target.value));
                          setCurrentPage(1);
                        }}
                      >
                        <option value={7}>7</option>
                        <option value={10}>10</option>
                        <option value={20}>20</option>
                        <option value={50}>50</option>
                      </select>
                    </div>
                  </div>
                </>
              )}

              {activeTab === 'blocked' && (
                <>
                  <div className="mb-6 font-bold">{blockedUsers.length} suspended users</div>
                  <ModerationTable
                    data={blockedUsers}
                    columns={blockedColumns(handleUnblock)}
                    loading={blockedLoading}
                  />
                </>
              )}
            </CustomTabs>
          </div>
        </Content>
      </Container>

      {/* Modals */}
      <ReportDetailDrawer
        report={reportDetails}
        reportLoading={reportLoading}
        open={isDrawerOpen}
        onClose={() => setIsDrawerOpen(false)}
        onDeleteClick={() => openActionModal('delete', selectedReport)}
        onBlockClick={handleDrawerBlockClick}
        onDismissClick={() => openActionModal('dismiss', selectedReport)}
      />

      <ActionConfirmationModal
        open={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        onConfirm={handleConfirmAction}
        message={modalContent.message}
        actionText={modalContent.actionText}
        isDestructive={modalContent.isDestructive}
        showReasonInput={modalContent.showReasonInput}
        reportData={selectedUser}
      />
    </div>
  );
};